import { render, staticRenderFns } from "./blog-comment-likes.vue?vue&type=template&id=4bb199ab&"
import script from "./blog-comment-likes.vue?vue&type=script&lang=js&"
export * from "./blog-comment-likes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports